import React, { useState } from 'react';
import { X, Lightbulb } from 'lucide-react';
import { LoadingScreen } from '@/components/ui/Loading';

interface FeedbackModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const FeedbackModal: React.FC<FeedbackModalProps> = ({ isOpen, onClose }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [prevIsOpen, setPrevIsOpen] = useState(isOpen);

    // Reset loading state when modal opens using derived state to avoid ESLint set-state-in-effect
    if (isOpen !== prevIsOpen) {
        setPrevIsOpen(isOpen);
        if (isOpen) {
            setIsLoading(true);
        }
    }

    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 bg-slate-900/70 backdrop-blur-sm z-[60] flex items-center justify-center p-4 animate-in fade-in duration-200"
            onClick={onClose}
            role="dialog"
            aria-modal="true"
            aria-label="Formulário de Feedback"
        >
            <div
                className="bg-white rounded-2xl shadow-2xl w-full max-w-xl flex flex-col overflow-hidden animate-in slide-in-from-bottom-4 duration-200"
                style={{ height: '85vh' }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header */}
                <div className="flex items-center justify-between px-5 py-4 border-b border-indigo-100 bg-gradient-to-r from-indigo-50 to-violet-50 shrink-0">
                    <div className="flex items-center gap-2.5">
                        <div className="bg-indigo-100 p-1.5 rounded-lg">
                            <Lightbulb size={18} className="text-indigo-500 fill-indigo-200" />
                        </div>
                        <div>
                            <h2 className="text-base font-bold text-slate-800">Dê o seu Feedback</h2>
                            <p className="text-xs text-slate-500">Sua opinião nos ajuda a melhorar</p>
                        </div>
                    </div>
                    <button
                        onClick={onClose}
                        className="p-1.5 rounded-lg text-slate-400 hover:text-slate-700 hover:bg-indigo-100 transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        aria-label="Fechar"
                    >
                        <X size={18} />
                    </button>
                </div>

                {/* Content */}
                <div className="flex-1 overflow-hidden bg-white relative">
                    {isLoading && (
                        <div className="absolute inset-0 z-10 bg-white">
                            <LoadingScreen message="Preparando formulário..." />
                        </div>
                    )}
                    <iframe
                        src="https://docs.google.com/forms/d/e/1FAIpQLSfJ8bJmM6PDAvwoWumN1o0f6_5gNh7G7JQZaffXOPsOy0WDsw/viewform?embedded=true"
                        width="100%"
                        height="100%"
                        frameBorder="0"
                        marginHeight={0}
                        marginWidth={0}
                        title="Formulário de Feedback PersonaLab"
                        className={`w-full h-full ${isLoading ? 'opacity-0' : 'opacity-100'} transition-opacity duration-300`}
                        onLoad={() => setIsLoading(false)}
                    >
                        Carregando formulário...
                    </iframe>
                </div>
            </div>
        </div>
    );
};
